import React from 'react'
import { Helmet } from 'react-helmet'
import { Container, Col, Row } from 'react-bootstrap'
import onlineDoctor from '../images/Online Doctor-rafiki.png'

const AboutUs = () => {
  return (
    <>
      {' '}
      <Helmet>
        <title>關於我們 | HA! CRM</title>
      </Helmet>
      <Container fluid className="aboutUs d-flex align-items-center">
        <Row className="justify-content-center align-items-center">
          <Col xs={4}>
            <h1 className="text-center">HA! 健康數據管理平台</h1>
            <p>
              「HA!」是一個健康CRM管理系統，專為診所而設計。它為病患提供方便的平台，讓他們能自行輸入簡單的健康行為資料和用藥紀錄。這些資料將提供給醫生作為參考，以便更好地了解病患的狀況。
            </p>
            <p>
              「HA!」不僅提供便利的使用者介面，還強調資料的安全性和隱私保護。透過這個系統，診所和醫生能夠更有效地管理病患的健康資訊，提供更精準的診斷和治療建議，以促進病患的健康和福祉。
            </p>
            <h5 className="pt-2">
              想了解更多：歡迎來信洽詢{' '}
              <a href="mailto:dkabio@dkabio.com">dkabio@dkabio.com</a>
            </h5>
          </Col>
          <Col xs={4} className="imgWrap ">
            <img
              className="w-100 drop-shadow"
              src={onlineDoctor}
              alt="onlineDoctor"
            />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default AboutUs
